import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

/**
 * Confirmation dialog for reactivating a cancelled subscription.
 * Use in admin subscription detail for Squarespace subscriptions.
 */
export default function ReactivateSubscriptionDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="reactivate-subscription-dialog-title"
      aria-describedby="reactivate-subscription-dialog-description"
    >
      <DialogTitle id="reactivate-subscription-dialog-title">
        Reactivate Subscription?
      </DialogTitle>
      <DialogContent>
        <Typography id="reactivate-subscription-dialog-description">
          Are you sure you want to reactivate this subscription? The status will
          be set to active and the change will be synced to Squarespace.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Keep Cancelled
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <PlayArrowIcon />
            )
          }
        >
          {loading ? "Reactivating..." : "Reactivate Subscription"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
